<template>
  <div class="section-abstract mb-1">
    <v-row class="ma-0 abstract-row" @click="openSection('SectionSalarieCiviliteExtend', 'salarie', false)">
      <v-col>
        <div class="section-abstract-title">État civil</div>
        <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">Nom de naissance</div>
            <div class="section-abstract-value">{{ salarie.nomNaissance }} <v-icon v-if="salarie.nomNaissance" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(salarie.nomNaissance, 0)">{{ copiedField === 0 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 2 / span 1;">
            <div class="section-abstract-label pt-2">Date de naissance</div>
            <div class="section-abstract-value">{{ formatDate(salarie.dateNaissance) }} <v-icon v-if="salarie.dateNaissance" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(formatDate(salarie.dateNaissance), 1)">{{ copiedField === 1 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 2 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">Numéro de Sécurité sociale</div>
            <div class="section-abstract-value">{{ salarie.numeroSecu }} <v-icon v-if="salarie.numeroSecu" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(salarie.numeroSecu, 2)">{{ copiedField === 2 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
        </div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
  import { defineComponent } from "vue";
  import SectionSalarieEtatCivilAbstract from '@/generated/sections/SectionSalarieEtatCivilAbstract.vue';
  import { DateFormat } from '@/framework/base/helpers/DateFormat';
  export default defineComponent({
    extends: SectionSalarieEtatCivilAbstract,
    components: {},  
     methods: {
      formatDate(value :Date | null): string {
        return DateFormat.getDateLabel(value); 
      }
    },
  })     
</script>
